import {
  Square,
  Stack,
  Text,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Flex,
  HStack,
} from '@chakra-ui/react';
import dayjs from 'dayjs';
import React from 'react';

const SingleTrasaction = (transaction) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <>
      <Square
        onClick={onOpen}
        {...transactionStyles}
        color={
          transaction?.transactionType === 'Credit' ? 'teal.400' : 'crimson'
        }
      >
        <Stack>
          <Text>{transaction?.services}</Text>
          <Text as='small' fontSize='normal'>
            {dayjs(transaction?.updatedAt).format('MMM ddd YYYY')}
          </Text>
        </Stack>
        <Text
          fontSize='1rem'
          // color={
          //   transaction?.transactionType === 'Credit' ? 'teal.400' : 'crimson'
          // }
        >
          &#8358; {transaction?.amount}
        </Text>
      </Square>

      <Modal
        isCentered
        motionPreset='slideInBottom'
        isOpen={isOpen}
        onClose={onClose}
        size='xs'
      >
        <ModalOverlay />
        <ModalContent py='5'>
          <ModalHeader textAlign='center'>
            <ModalCloseButton />
            <Stack>
              <Text fontSize='14px'>Amount</Text>
              <Text>&#8358; {transaction?.amount}</Text>
              <Flex justify='center'>
                <Square
                  w='80px'
                  borderRadius='20px'
                  border='1px solid #FEE8E7'
                  bg='#FAF6FF'
                  fontSize='12px'
                >
                  {transaction?.transactionType === 'Credit'
                    ? 'Credit'
                    : 'Debit'}
                </Square>
              </Flex>
            </Stack>
          </ModalHeader>

          <ModalBody pb='5'>
            <Stack spacing='5' fontSize='16px'>
              <HStack justify='space-between' borderBottom='1px solid #ddd'>
                <Text>UserId</Text>
                <Text>{transaction?.benefeciary}</Text>
              </HStack>
              <HStack justify='space-between' borderBottom='1px solid #ddd'>
                <Text>Channel</Text>
                <Text>{transaction?.transactionChannel}</Text>
              </HStack>
              <HStack justify='space-between' borderBottom='1px solid #ddd'>
                <Text>Transaction type</Text>
                <Text>{transaction?.transactionType}</Text>
              </HStack>
              <HStack justify='space-between' borderBottom='1px solid #ddd'>
                <Text>Balance</Text>
                <Text>&#8358; {transaction?.balanceAfter}</Text>
              </HStack>
            </Stack>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};

export default SingleTrasaction;

const transactionStyles = {
  bg: 'bgColorLight',
  py: '3',
  px: '10',
  justifyContent: 'space-between',
  fontWeight: 'bold',
  borderRadius: '5px',
  cursor: 'pointer',
};
